import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
import { GoogleSearchConsoleServiceComponent } from './GoogleSearchConsoleServiceComponent';
export const GoogleSearchConsoleReconnectionConfig = {
  reconnectButton: null,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED, AppConnectionStatuses.UPDATE_AVAILABLE],
  serviceComponent: GoogleSearchConsoleServiceComponent
};